import { AsyncPipe, UpperCasePipe } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatCard, MatCardContent } from '@angular/material/card';
import { MatError, MatFormField, MatPrefix, MatSuffix } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatLabel } from '@angular/material/select';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { APPLICATION_TYPE } from '@core';
import { Store } from '@ngrx/store';
import { AuthActions, AuthSelectors } from '@ngrx-store';
import { MainLogoComponent } from '@ui';
import { Observable } from 'rxjs';

import { passwordValidationPattern } from '../../constants';
import { formUtils } from '../../helpers';
import { PasswordRequirementsComponent } from '../password-requirements/password-requirements.component';

@Component({
  imports: [
    MainLogoComponent,
    MatCard,
    MatCardContent,
    ReactiveFormsModule,
    MatFormField,
    MatIcon,
    MatInput,
    PasswordRequirementsComponent,
    AsyncPipe,
    MatProgressSpinner,
    MatSuffix,
    MatPrefix,
    UpperCasePipe,
    MatError,
    MatLabel,
    RouterLink,
  ],
  selector: 'avs-li-password-recovery',
  standalone: true,
  templateUrl: './password-recovery.component.html',
})
export class PasswordRecoveryComponent {
  protected form: FormGroup;
  protected instructionsSent = false;
  protected isLoading$: Observable<boolean | undefined>;
  protected appType = inject(APPLICATION_TYPE);
  protected isMobile = signal(false);
  private fb = inject(FormBuilder);
  private route = inject(ActivatedRoute);
  private store = inject(Store);

  constructor() {
    this.isMobile.set(this.appType === 'mobile');
    this.isLoading$ = this.store.select(AuthSelectors.isLoading);
    this.instructionsSent = this.route.snapshot.paramMap.get('state') === 'success';
    this.form = this.fb.group(
      {
        confirmPassword: ['', [Validators.required, Validators.pattern(passwordValidationPattern)]],
        password: ['', [Validators.required, Validators.pattern(passwordValidationPattern)]],
        token: [this.route.snapshot.queryParams['token'], [Validators.required]],
        userPolicyId: [this.route.snapshot.queryParams['policyId'], [Validators.required]],
      },
      {
        validator: formUtils.confirmedValidator('password', 'confirmPassword'),
      },
    );
  }

  protected saveChanges() {
    if (this.form.valid) {
      this.store.dispatch(AuthActions.passwordRecovery({ recoveryData: this.form.value }));
    } else {
      this.form.markAllAsTouched();
    }
  }
}
